import { render, staticRenderFns } from "./ViewRecord.vue?vue&type=template&id=497ad59c"
import script from "./ViewRecord.vue?vue&type=script&lang=js"
export * from "./ViewRecord.vue?vue&type=script&lang=js"
import style0 from "./ViewRecord.vue?vue&type=style&index=0&id=497ad59c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports